<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>処分事業場詳細（再資源）</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              事業場コード
            </div>
            <h4>{{ final_disposal_site.code }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <div class="overline">
              処分事業者名
            </div>
            <h4>{{ final_disposal_site.trader_name }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="4">
            <div class="overline">
              許可番号（下6桁）
            </div>
            <h4>{{ final_disposal_site.recycle_permission_number }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="4">
            <div class="overline">
              事業場区分
            </div>
            <h4>{{ final_disposal_site.location_type === 'only_middle' ? '中間' : '最終(再生含む)' }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              処分事業場名
            </div>
            <h4>{{ final_disposal_site.name }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="12">
            <div class="overline">
              所在地
            </div>
            <h4>〒{{ final_disposal_site.zip_code }}&emsp;{{ final_disposal_site.address }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              電話番号
            </div>
            <h4>{{ final_disposal_site.phone_number }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <div class="overline">
              許可番号
            </div>
            <h4>{{ final_disposal_site.permission_number }}&nbsp;</h4>
            <v-divider />
          </v-col>

          <v-col cols="12" md="4">
            <div class="overline">
              処分方法
            </div>
            <h4>{{ final_disposal_site.disposal_method_name }}&nbsp;</h4>
            <v-divider />
          </v-col>

          <v-col cols="12" md="4">
            <div class="overline">
              処理能力
            </div>
            <h4>{{ final_disposal_site.processing_power }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <div class="overline">
              表示順
            </div>
            <h4>{{ final_disposal_site.sort_priority }}&nbsp;</h4>
            <v-divider />
          </v-col>

        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="error"
          :disabled="isJwMode"
          @click="deleteButtonClickEvent"
        >
          削除
        </v-btn>
        <v-spacer />
        <v-btn
          @click="cancelButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          :disabled="isJwMode"
          color="primary"
          @click="editButtonClickEvent"
        >
          編集
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import Confirm from '../../../../components/Confirm'
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
  name: 'DriverMasterFinalDisposalSiteShow',
  components: {
    Confirm
  },
  mixins: [],
  props: {},
  data () {
    return {
      breadcrumbs: [
        { text: '処分事業場一覧（再資源）', disabled: false, to: '/driver/masters/final_disposal_sites', exact: true },
        { text: '処分事業場詳細（再資源）', disabled: true, to: '' },
      ],
      final_disposal_site: {},
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
      isJwMode: 'use_jw_mode',
    }),
  },
  watch: {},
  created() {
    this.fetchFinalDisposalSite({ id: this.$route.params.id }).then((content) => {
      this.final_disposal_site = content
    })
  },
  methods: {
    ...mapActions('DriverMasterFinalDisposalSite', {
      fetchFinalDisposalSite: 'show',
      deleteFinalDisposalSites: 'destroy',
    }),
    /**
     * 編集ボタン クリックイベント
     * @param item { Object }
     */
     editButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterFinalDisposalSiteEdit', params: { id: String(this.final_disposal_site.id) }})
    },
    /**
     * 閉じるボタン クリックイベント
     * @param item { Object }
     */
     cancelButtonClickEvent: function() {
      this.$router.push({ name: 'DriverMasterFinalDisposalSites' })
    },
    /**
     * 削除ボタン クリックイベント
     * @param item { Object }
     */
     deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteFinalDisposalSites({id: this.final_disposal_site.id }).then(() =>{
            this.$router.push({name: 'DriverMasterFinalDisposalSites'})
          })
        }
      })
    },
  }
}
</script>
